import { HelperCore } from '@/common/helper';
import { makeAutoObservable, runInAction } from 'mobx';

class EnhanceStore {
  type = "copilot";     // copilot: 追问 flow: 工作流步骤
  isFolded = false;     // 是否折叠
  questions = [];       // 追问问题
  flows = [];           // 工作流步骤

  get output () {
    return this.questions.map(item => {
      item = HelperCore.copyObj(item);
      item.response = String(item.value || "");
      delete(item.value);

      return item;
    })
  }
  // 用户是否已输入，是否已输入都可以点击，只是改个按钮样式
  get hasInputed () {
    return this.output.some(item => item.response);
  }
  get supportFold () {
    return this.type == "flow";
  }

  constructor ({ type }) {
    this.type = type;
    makeAutoObservable(this);
  }

  setFolded (isFolded) {
    this.isFolded = isFolded;
  }
  toggleFolded = () => {
    this.setFolded(!this.isFolded);
  }

  /**
   * 输入变化
   */
  updateData (data) {
    Object.keys(data).forEach(key => {
      let inputData = HelperCore.copyObj(data[key]);

      switch(key){
        case "type":{
          // 追问不支持收起
          if(data[key] != "flow"){
            this.isFolded = false;
          }
          break;
        }
        case "flows":{
          if(inputData){
            const flows = [
              {
                icon : "https://p0.ssl.qhimg.com/t01c3ba618e6e71dbee.png",
                text : "分析问题语义",
              },
            ];
            const { search_keyword, refer_search } = inputData;
            if(search_keyword?.length && search_keyword.filter(_ => _.content).length){
              flows.push({
                icon : "https://p2.ssl.qhimg.com/t01923e3cad8eb23b06.png",
                text : `提炼出 <span style="padding-left:8px;padding-right:8px;color:var(--text-color-active);font-weight:bold;">${search_keyword.length}个</span> 搜索关键词`,
                tips : search_keyword,
              });
            }
            if(refer_search?.length){
              flows.push({
                icon : "https://p0.ssl.qhimg.com/t01c3ba618e6e71dbee.png",
                text : `选出 <span style="padding-left:8px;padding-right:8px;color:var(--text-color-active);font-weight:bold;">${refer_search.length}个</span> 相关结果`,
                list : refer_search,
                isResult : true,
                isRefer : true,
              });
            }
            inputData = flows;
          }
          break;
        }
      }

      this[key] = inputData;
    });
  }

  /**
   * 用户操作
   */
  toggleSelectOption(index, answer) {
    const value = this.questions[index].value.includes(answer);
    if(value){
      this.questions[index].value = this.questions[index].value.filter(item => item != answer);
    }
    else {
      this.questions[index].value.push(answer);
    }
  }
  inputAnswer = (index, value) => {
    this.questions[index].value = value;
  }
}


export default EnhanceStore;